const isLocal = window.document.location.href.includes('localhost')
export const common = {
  imgPrefix: isLocal
    ? 'https://community-test.jiketravel.com/'
    : window.document.location.origin + '/'
}
